import { render, staticRenderFns } from "./SuppliesCompanyEducationUpdate.vue?vue&type=template&id=8473806c"
import script from "./SuppliesCompanyEducationUpdate.vue?vue&type=script&lang=js"
export * from "./SuppliesCompanyEducationUpdate.vue?vue&type=script&lang=js"
import style0 from "./SuppliesCompanyEducationUpdate.vue?vue&type=style&index=0&id=8473806c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports